import * as React from "react";
const SvgFiRrComplianceDocument = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-compliance-document_svg__a)">
      <path
        fill="#062147"
        d="M12 22H5c-1.654 0-3-1.346-3-3V5c0-1.654 1.346-3 3-3h4.515q.245 0 .485.023V7c0 1.654 1.346 3 3 3h5.813a1 1 0 0 0 .969-1.248 7 7 0 0 0-1.833-3.217l-3.484-3.484A6.96 6.96 0 0 0 9.515 0H5C2.243 0 0 2.243 0 5v14c0 2.757 2.243 5 5 5h7a1 1 0 1 0 0-2m0-19.341q.571.328 1.051.806l3.484 3.484c.314.314.584.668.804 1.051H13a1 1 0 0 1-1-1zM11 18a1 1 0 0 1-1 1H5a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1m0-4a1 1 0 0 1-1 1H5a1 1 0 1 1 0-2h5a1 1 0 0 1 1 1m11.63-1.685-3.815-1.265a1 1 0 0 0-.629 0l-3.815 1.265a1.995 1.995 0 0 0-1.37 1.896v3.324c0 3.57 3.715 5.703 4.85 6.27 0 0 .306.209.651.209s.582-.156.582-.156c1.153-.464 4.917-2.292 4.917-6.322v-3.324c0-.862-.551-1.625-1.37-1.896zM22 17.536c0 2.581-2.423 3.924-3.454 4.379-.914-.49-3.546-2.098-3.546-4.379v-3.322l3.5-1.16 3.5 1.158z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-compliance-document_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrComplianceDocument;
